import { render, staticRenderFns } from "./ModalAreaAcao.vue?vue&type=template&id=0f0ac223&scoped=true"
import script from "./ModalAreaAcao.vue?vue&type=script&lang=js"
export * from "./ModalAreaAcao.vue?vue&type=script&lang=js"
import style0 from "./ModalAreaAcao.vue?vue&type=style&index=0&id=0f0ac223&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0ac223",
  null
  
)

export default component.exports